import Lightning from '@lightningjs/sdk/src/Lightning';
import { Column, Row } from '@lightningjs/ui-components';
import { KeyboardRow } from './KeyboardRow';
import Key from './Key';
import { Colors } from '@lightningjs/sdk';
import {
  keyboardABC,
  keyboardabc,
  keyboardNumbers,
  keyboardOptions,
  keyboardSpecial,
} from './keyboardKeys';
import ButtonOption from './ButtonOption';

export default class Keyboard extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 200,
      y: 80,
      Keyboard: {
        y: 20,
        collision: true,
        type: Column,
        plinko: true,
        flex: { direction: 'column', justifyContent: 'center', alignItems: 'center' },
        style: {
          itemSpacing: 0,
        },
        neverScroll: true,
      },
      KeyboardOptions: {
        plinko: true,
        collision: true,
        w: 1920,
        h: 200,
        flex: { direction: 'row', justifyContent: 'center', alignItems: 'center' },
        type: Row,
        style: { itemSpacing: 0 },
      },
    };
  }
  _active() {
    this._setState('Keyboard');
    const optionItems = keyboardOptions.map((option, index) => ({
      collision: true,
      type: ButtonOption,
      index,
      data: option,
      // rect: true,
      // color: Colors('#444444').get(),
    }));

    const items = keyboardabc.map((keys, rowIndex) => ({
      type: KeyboardRow,
      h: 100,
      w: 1920,
      collision: true,
      rowIndex: rowIndex,
      flex: { direction: 'row', justifyContent: 'center', alignItems: 'center' },
      style: {
        itemSpacing: 2,
      },
      items: keys.map((key, index) => ({
        type: Key,
        data: key,
        collision: true,
        index,
        rowIndex: rowIndex,
      })),
    }));
    this.tag('KeyboardOptions').patch({
      items: optionItems,
      shader: { type: Lightning.shaders.RoundedRectangle, radius: 15 },
      w: 400,
      color: Colors('#444444').get(),
      h: 60,
      rect: true,
    });
    this.tag('Keyboard').patch({
      w: 400,
      items: items,
    });
  }

  set limit(val) {
    this._limit = val;
  }

  get _Keyboard() {
    return this.tag('Keyboard');
  }

  $setFocusKey({ row, index }) {
    this._Keyboard.selectedIndex = row;
    this._Keyboard.items[row].selectedIndex = index;
  }

  $setFocusKeyOption({ index }) {
    this.tag('KeyboardOptions').selectedIndex = index;
  }

  _setKeyboard(keyboard) {
    const items = keyboard.map((keys, rowIndex) => ({
      type: KeyboardRow,
      h: 100,
      w: 1920,
      collision: true,
      rowIndex: rowIndex,
      flex: { direction: 'row', justifyContent: 'center', alignItems: 'center' },
      style: {
        itemSpacing: 2,
      },
      items: keys.map((key, index) => ({
        type: Key,
        data: key,
        collision: true,
        index,
        rowIndex: rowIndex,
      })),
    }));
    this.tag('Keyboard').patch({
      w: 400,
      h: 200,
      items: items,
    });
  }

  $changeKeyboard(key) {
    switch (key) {
      case 'ABC':
        this._setKeyboard(keyboardABC);
        break;
      case 'abc':
        this._setKeyboard(keyboardabc);
        break;
      case '123':
        this._setKeyboard(keyboardNumbers);
        break;
      case '#+-':
        this._setKeyboard(keyboardSpecial);
    }
  }

  $onSoftKey({ key }) {
    const inputTag = this.parent._InputField.tag('Input');
    if (!inputTag.listening) return;
    switch (key) {
      case 'space':
        inputTag.insert('\u00A0');
        break;
      case 'delete':
      case 'backspace':
        inputTag.backspace();
        break;
      case 'clear':
        inputTag.clear();
        break;
      case 'Done':
        this.fireAncestors('$pressedDone');
        break;
      default:
        if (inputTag.value.length < this._limit) {
          inputTag.insert(key);
        }
    }
    this.parent._changePlaceholder();
  }

  $setState(state) {
    this.fireAncestors('$setState', 'Keyboard');
    this._setState(state);
  }

  static _states() {
    return [
      class Keyboard extends this {
        _getFocused() {
          return this._Keyboard;
        }
        _handleDown() {
          this._setState('KeyboardOptions');
        }
      },
      class KeyboardOptions extends this {
        _getFocused() {
          return this.tag('KeyboardOptions');
        }
        _handleUp() {
          this._setState('Keyboard');
        }
      },
    ];
  }
}
